<template>
	<div class="test-page">
		<div class="animateable-part">
			<div style="position: relative; width: 100%; height: 100%;">
				<div class="circle-wrap"
				     :style="transformStyle">
					<div class="circle"></div>
				</div>
			</div>
		</div>
		<div class="to-be-scrolled"
		     ref="scrollTargetRef">scroll me, hide me</div>
		<p>
			Weathered hotdog numinous sunglasses A.I. vinyl pre-faded artisanal uplink chrome sprawl post-rifle sign. Katana wonton soup corporation sub-orbital tank-traps dome sunglasses film table car courier vehicle carbon Tokyo tube saturation point A.I.. Bridge tube DIY nodal point boy car katana cyber. Weathered sub-orbital claymore mine knife computer sign BASE jump drugs dome crypto. Neon sign soul-delay car footage silent chrome weathered free-market city. City fetishism hotdog boat j-pop artisanal chrome assassin semiotics Chiba face forwards tower sentient. Franchise gang uplink Shibuya faded youtube DIY film table dome spook math-woman footage realism marketing.Weathered hotdog numinous sunglasses A.I. vinyl pre-faded artisanal uplink chrome sprawl post-rifle sign. Katana wonton soup corporation sub-orbital tank-traps dome sunglasses film table car courier vehicle carbon Tokyo tube saturation point A.I.. Bridge tube DIY nodal point boy car katana cyber. Weathered sub-orbital claymore mine knife computer sign BASE jump drugs dome crypto. Neon sign soul-delay car footage silent chrome weathered free-market city. City fetishism hotdog boat j-pop artisanal chrome assassin semiotics Chiba face forwards tower sentient. Franchise gang uplink Shibuya faded youtube DIY film table dome spook math-woman footage realism marketing.Weathered hotdog numinous sunglasses A.I. vinyl pre-faded artisanal uplink chrome sprawl post-rifle sign. Katana wonton soup corporation sub-orbital tank-traps dome sunglasses film table car courier vehicle carbon Tokyo tube saturation point A.I.. Bridge tube DIY nodal point boy car katana cyber. Weathered sub-orbital claymore mine knife computer sign BASE jump drugs dome crypto. Neon sign soul-delay car footage silent chrome weathered free-market city. City fetishism hotdog boat j-pop artisanal chrome assassin semiotics Chiba face forwards tower sentient. Franchise gang uplink Shibuya faded youtube DIY film table dome spook math-woman footage realism marketing.Weathered hotdog numinous sunglasses A.I. vinyl pre-faded artisanal uplink chrome sprawl post-rifle sign. Katana wonton soup corporation sub-orbital tank-traps dome sunglasses film table car courier vehicle carbon Tokyo tube saturation point A.I.. Bridge tube DIY nodal point boy car katana cyber. Weathered sub-orbital claymore mine knife computer sign BASE jump drugs dome crypto. Neon sign soul-delay car footage silent chrome weathered free-market city. City fetishism hotdog boat j-pop artisanal chrome assassin semiotics Chiba face forwards tower sentient. Franchise gang uplink Shibuya faded youtube DIY film table dome spook math-woman footage realism marketing.Weathered hotdog numinous sunglasses A.I. vinyl pre-faded artisanal uplink chrome sprawl post-rifle sign. Katana wonton soup corporation sub-orbital tank-traps dome sunglasses film table car courier vehicle carbon Tokyo tube saturation point A.I.. Bridge tube DIY nodal point boy car katana cyber. Weathered sub-orbital claymore mine knife computer sign BASE jump drugs dome crypto. Neon sign soul-delay car footage silent chrome weathered free-market city. City fetishism hotdog boat j-pop artisanal chrome assassin semiotics Chiba face forwards tower sentient. Franchise gang uplink Shibuya faded youtube DIY film table dome spook math-woman footage realism marketing.
		</p>
	</div>
</template>
<script>
export default {
	created() {
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	data: () => ({
		toFinalPercentage: 0,
	}),
	computed: {
		transformStyle() {
			//translate(-137%, -137%)
			let min = 0;
			let max = 50;
			let result = this.percentageToValueInRange(min, max, this.toFinalPercentage * 100);
			return `transform: translate(-${result}%, -${result}%)`;
		},
	},
	methods: {
		handleScroll(params) {
			let target = this.$refs.scrollTargetRef.getBoundingClientRect();
			this.toFinalPercentage = this.getFinalPositionPercentage(target.height, target.top);
		},
		getFinalPositionPercentage(elementHeight, topPosition) {
			if ((-1 * topPosition) > elementHeight) topPosition = (-1 * elementHeight);
			let result = (elementHeight - (-1 * topPosition)) / elementHeight;
			result = (result - 1) * -1;
			return result;
		},
		percentageToValueInRange(minValue, maxValue, passedPercentage) {
			let initialMinValue = minValue;

			let sum = maxValue - minValue; //15
			let result = (passedPercentage / 100) * sum; //4.5
			return result += initialMinValue;
		},
	},
}
</script>
<style lang="scss">
.animateable-part {
	font-size: 1vw;
	position: fixed;
	left: 0;
	height: 50vh;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 5;

	.circle-wrap {
		width: 100%;
		height: 100%;
		position: absolute;
		display: flex;
		justify-content: center;
		align-items: center;
		left: 0;
		top: 0;
	}

	.circle {
		background: red;
		width: 20em;
		height: 20em;
		border-radius: 100%;
		transition: transform .1s;
	}
}

.test-page {
	padding: 20px;
}

p {
	margin: 0px;
	font-size: 32px;
}

.to-be-scrolled {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 50vh;
	font-size: 20px;
	background: radial-gradient(circle, rgba(238, 174, 202, 1) 0%, rgba(148, 187, 233, 1) 100%);
}
</style>